import { useMutation } from "react-query";
import { upsertDepressionScreening } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertDepressionScreening = (options: Record<string, any> = {}) => {
  const { onError = () => {}, onSuccess = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      upsertDepressionScreening(clientId, payload),
    {
      onSuccess: (response: any, variables: any) => {
        showToast({
          message: "Depression screening updated successfully",
          errorState: false,
        });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        showToast({
          message: "Whoops! Something went wrong while updating the depression screening.",
          errorState: true,
        });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    upsertDepressionScreeningMutation: mutate,
    isUpsertDepressionScreeningLoading: isLoading,
    ...rest,
  };
};

export default useUpsertDepressionScreening;
